import React from "react";

/**
 * Step 1: account password setup (first / last name, password, confirm).
 */
const VendorOnboardingStepPassword = ({
  accountData,
  formErrors,
  passwordShownn,
  passwordShown,
  togglePasswordd,
  togglePassword,
  handleChange,
  handleSubmit,
}) => (
  <>
    <div className="bg-light rounded-3 p-3 mb-3">
      <div className="row">
        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="pr-fn">
            First name
          </label>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type="text"
            name="firstName"
            value={accountData.firstName}
            onChange={handleChange}
          />
          {formErrors.firstName && (
            <div className="invalid-tooltip">{formErrors.firstName}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="pr-sn">
            Last Name
          </label>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type="text"
            name="lastName"
            value={accountData.lastName}
            onChange={handleChange}
          />
          {formErrors.lastName && (
            <div className="invalid-tooltip">{formErrors.lastName}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="pr-phone">
            Password
          </label>
          <span className="text-danger">*</span>
          <div className="password-toggle">
            <label
              className="password-toggle-btn"
              aria-label="Show/hide password"
              onClick={togglePasswordd}
            >
              <span className="password-toggle-indicator"></span>
            </label>
          </div>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type={passwordShownn ? "text" : "password"}
            placeholder="create a password"
            name="passwordHash"
            value={accountData.passwordHash}
            onChange={handleChange}
          />
          {formErrors.passwordHash && (
            <div className="invalid-tooltip">{formErrors.passwordHash}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="pr-phone">
            Confirm Password
          </label>
          <span className="text-danger">*</span>
          <div className="password-toggle">
            <label
              className="password-toggle-btn"
              aria-label="Show/hide password"
              onClick={togglePassword}
            >
              <span className="password-toggle-indicator"></span>
            </label>
          </div>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type={passwordShown ? "text" : "password"}
            name="confirmPassword"
            placeholder="confirm password"
            value={accountData.confirmPassword}
            onChange={handleChange}
          />
          {formErrors.confirmPassword && (
            <div className="invalid-tooltip">{formErrors.confirmPassword}</div>
          )}
        </div>
      </div>
    </div>
    <div className="pull-right mt-3">
      <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
        Next step
        <i className="fi-chevron-right fs-sm ms-2"></i>
      </button>
    </div>
  </>
);

export default VendorOnboardingStepPassword;
